import React from 'react'
import './newMatches.css'
import { Outlet } from 'react-router-dom';
import LinksWidget from './LinksWidget';

function LinksMatchesScreen({ links }) {

    return (
        <div className="container new-matches-container">
            <div className="row">
                <div className="col col-md-3 col-lg-2">
                    <LinksWidget links={links} />
                </div>
                <div className="col col-md-9 col-lg-9">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default LinksMatchesScreen